import Vue from "vue";
import Router from "vue-router";
import auth from "@/auth/authService";

// import firebase from 'firebase/app'
import { firebaseInstance as firebase } from "@/main";
import serviforms from "./serviforms";
import "firebase/auth";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import(/* webpackChunkName: "Main" */ "@/layouts/main/Main.vue"),
      children: [
        {
          path: "/",
          redirect: "/dashboard/new/form"
        },
        {
            path: '/dashboard/analytics',
            name: 'dashboard-analytics',
            component: () =>
                import(
                    /* webpackChunkName: "DashboardAnalytics" */ '@/serviforms/dashboard/dashboard.vue'
                ),
            meta: {
                rule: 'all',
                autentication: true
            },
        },
        ...serviforms,
        {
          path: "/dashboard/users/edit/:id",
          name: "usersedit",
          component: () =>
            import(/* webpackChunkName: "UsersList" */ "@/serviforms/designer/provider/clases-questions.js"),
          meta: {
            breadcrumb: [{ title: "Home", url: "/" }, { title: "Dashboard" }, { title: "Edit User", active: true }],
            //pageTitle: 'List View',
            rule: "admin",
            autentication: true
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/callback",
          name: "auth-callback",
          component: () => import("@/views/Callback.vue"),
          meta: {
            rule: "express"
          }
        },
        {
          path: "/pages/login",
          name: "page-login",
          component: () => import("@/serviforms/login/Login.vue"),
          meta: {
            rule: "all",
            autentication: false
          }
        },
        {
          path: "/pages/forgot-password/:email?",
          name: "page-forgot-password",
          component: () => import("@/serviforms/login/ForgotPassword.vue"),
          meta: {
            rule: "all"
          }
        },
        {
          path: "/pages/reset-password",
          name: "page-reset-password",
          component: () => import("@/views/pages/ResetPassword.vue"),
          meta: {
            rule: "all"
          }
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
          meta: {
            rule: "all"
          }
        },
        {
          path: "/pages/error-500",
          name: "page-error-500",
          component: () => import("@/views/pages/Error500.vue"),
          meta: {
            rule: "all"
          }
        },
        {
          path: "/pages/not-authorized",
          name: "page-not-authorized",
          component: () => import("@/views/pages/NotAuthorized.vue"),
          meta: {
            rule: "all"
          }
        },
        {
          path: "/pages/maintenance",
          name: "page-maintenance",
          component: () => import("@/views/pages/Maintenance.vue"),
          meta: {
            rule: "all"
          }
        },
        {
          path: "/pages/access/form/:token?/:company_id?",
          name: "Connect",
          component: () => import(/* webpackChunkName: "Connect" */ "@/serviforms/Connect/Main.vue"),
          meta: {
            rule: "all",
            autentication: false
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404"
    }
  ]
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

const validateRouter = (to, from, next) => {
  const firebaseCurrentUser = firebase.auth().currentUser;
  if (firebaseCurrentUser !== null && firebaseCurrentUser !== "null") {
    if (to.name !== from.name) {
      if (to.meta.autentication) {
        return next();
      } else {
        return next({ name: "newForm" });
      }
    } else if (to.path !== from.path) return next();
  } else {
    if (to.meta.autentication) {
      return next({ name: "page-login" });
    } else {
      return next();
    }
  }
};

router.beforeEach((to, from, next) => {
  const firebaseCurrentUser = firebase.auth().currentUser;

  if (firebaseCurrentUser === null) {
    let count = 0;
    firebase.auth().onAuthStateChanged(user => {
      if (count === 0) validateRouter(to, from, next);
      count++;
    });
  } else {
    validateRouter(to, from, next);
  }
});

export default router;
